// extracted by mini-css-extract-plugin
export var aws = "Footer-module--aws--e6023";
export var bInfo = "Footer-module--bInfo--defc7";
export var bLinks = "Footer-module--bLinks--f2fe8";
export var col = "Footer-module--col--35088";
export var colItem = "Footer-module--colItem--1da80";
export var copyright = "Footer-module--copyright--a775b";
export var copyrightItem = "Footer-module--copyrightItem--1f1a0";
export var copyrightWrapper = "Footer-module--copyrightWrapper--d33da";
export var heading = "Footer-module--heading--3436a";
export var inner = "Footer-module--inner--461ba";
export var link = "Footer-module--link--e0d8f";
export var linkForm = "Footer-module--linkForm--ff8ca";
export var logo = "Footer-module--logo--2eef9";
export var partner = "Footer-module--partner--6c549";
export var root = "Footer-module--root--388e1";
export var socialIcons = "Footer-module--socialIcons--9e071";
export var socialLink = "Footer-module--socialLink--184e5";
export var surveycake = "Footer-module--surveycake--8444c";
export var twm = "Footer-module--twm--46e5a";
export var wrapper = "Footer-module--wrapper--46564";